import { motion } from 'framer-motion'
import { useOnboardingStore } from '../store/onboardingStore'
import { Button } from '../components/Button'
import { V2Icon } from '../components/v2'
import { usesAppLook } from '../lib/variant'

export function TestimonialStep() {
  const { goNext } = useOnboardingStore()
  const v2 = usesAppLook()

  return (
    <div className="min-h-dvh flex flex-col bg-gradient-to-b from-teal-600 to-teal-800">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md text-center"
        >
          <img src="/images/mascot-thinking.png" alt="KidneyPal mascot" className="h-28 mx-auto mb-5 object-contain" />

          <span className="inline-block text-xs font-bold uppercase tracking-widest text-teal-200 mb-2">
            Did you know?
          </span>

          <h1 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight">
            Hidden phosphorus is in 44% of grocery store foods
          </h1>

          <p className="text-teal-100 text-sm leading-relaxed mb-6">
            Phosphorus additives are added to processed foods but rarely listed clearly on labels. Over time, excess phosphorus can silently damage kidneys.
          </p>

          {/* Common food categories */}
          <div className="grid grid-cols-3 gap-3 mb-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3">
              {v2 ? <V2Icon name="food-packaged" className="block mx-auto mb-1" /> : <span className="text-2xl block mb-1">🥩</span>}
              <p className="text-xs text-teal-100 font-medium">Deli Meats</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3">
              {v2 ? <V2Icon name="food-soda" className="block mx-auto mb-1" /> : <span className="text-2xl block mb-1">🥤</span>}
              <p className="text-xs text-teal-100 font-medium">Sodas</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3">
              {v2 ? <V2Icon name="food-meal" className="block mx-auto mb-1" /> : <span className="text-2xl block mb-1">🍕</span>}
              <p className="text-xs text-teal-100 font-medium">Frozen Meals</p>
            </div>
          </div>

          {/* Scanner callout */}
          <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-4 mb-8">
            <p className="text-white font-semibold text-sm">
              KidneyPal's AI scanner detects these hidden additives instantly.
            </p>
          </div>

          <Button onClick={() => goNext()} variant="white">
            Continue
          </Button>
        </motion.div>
      </div>
    </div>
  )
}
